<script lang="ts">
	import { browser } from '$app/environment';
	import { useThemeStore, type Theme } from '$lib/stores/theme.svelte';
	import { Moon, Sun } from 'lucide-svelte';

	const theme = useThemeStore();

	function setCookie(t: Theme) {
		if (!browser || !t) return;
		document.cookie = `theme=${t}; path=/; max-age=31536000`;
	}

	function setStyle(t: Theme) {
		if (!browser) return;
		if (t === 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
	}

	function setTheme(t: Theme) {
		theme.value = t;
		setStyle(t);
		setCookie(t);
	}
</script>

<div class="flex items-center gap-x-1">
	{#if theme.value === 'dark'}
		<button
			type="button"
			class="p-2"
			onclick={() => setTheme('light')}
			title="Light mode"
			aria-label="Light mode"
		>
			<Sun />
			<span class="sr-only">Light mode</span>
		</button>
	{:else}
		<button
			type="button"
			class="p-2"
			onclick={() => setTheme('dark')}
			title="Dark mode"
			aria-label="Dark mode"
		>
			<Moon />
			<span class="sr-only">Dark mode</span>
		</button>
	{/if}
</div>
